/**
 * WordPress dependencies
 */
import { createContext, useContext } from '@wordpress/element';

/**
 * Internal dependencies
 */

export const NavigationMenuContext = createContext({
  menu: undefined,
  search: ''
});
NavigationMenuContext.displayName = 'NavigationMenuContext';
export const useNavigationMenuContext = () => useContext(NavigationMenuContext);